import { toast } from 'react-toastify'
// import Notification, { type } from '../toast/Toast'

interface ICatchException {
    stateType: string
    method: string
    dispatch: any
    e: any
}

export default function catchException({
    e,
    dispatch,
    stateType,
    method,
}: ICatchException) {
    // console.log('e', e)
    if (e.response) {
        switch (e.response.status) {
            case 500:
                // Notification( type.danger, 'Error en el Servidor');
                toast.error('Error en el Servidor')
                dispatch({
                    type: stateType,
                    payload: {
                        type: '500',
                        text: 'Error interno del Servidor',
                        status: method === 'get' ? 'error' : 'not',
                    },
                })
                break

            case 401:
                // Notification( type.warning, 'Su sesión ha expirado, ingrese nuevamente');
                // console.log('error sesion expirada!!!!!')
                toast.warning('Su sesión ha expirado, ingrese nuevamente')
                // dispatch({ type: 'CLEAR_USER' })
                dispatch({
                    type: stateType,
                    payload: {
                        type: '401',
                        text: 'Sesión Expirada',
                        status: 'token',
                    },
                })
                break

            case 404:
                // Notification( type.warning, 'Recurso no encontrado');
                toast.warning('Recurso no encontrado')
                dispatch({
                    type: stateType,
                    payload: {
                        type: '404',
                        text: 'El recurso solicitado no se encuentra disponible',
                        status: method === 'get' ? 'error' : 'not',
                    },
                })
                break

            case 409:
                // Notification( type.warning, e.response.data.message );
                toast.warning(e.response.data.message)
                dispatch({
                    type: stateType,
                    payload: {
                        type: '409',
                        text: e.response.data.message,
                        status: method === 'get' ? 'error' : 'not',
                    },
                })
                break

            default:
                // Notification( type.danger, 'Error Inesperado' )
                toast.error('Error Inesperado')
                dispatch({
                    type: stateType,
                    payload: { type: 'Oops', text: 'Ocurrió un error inesperado' },
                })
                break
        }
    } else {
        // Notification( type.danger, 'Error de Conexión' )
        toast.error('Error de Conexión')
        dispatch({
            type: stateType,
            payload: {
                type: 'Error de Conexión',
                text: 'Verifique que el servicio se encuentre operativo',
                status: 'error',
            },
        })
    }
}
